import styled from "styled-components";
import { Typography, colors } from "@innerhour/shiny-guide";
import FlexBox from "../common/FlexBox";

/**
 * @description
 * Chat info panel displayed in the empty chat state or accessible via menu.
 * Shows helpful information about chat features:
 * - Add New Notes: Quickly add session notes based on chat context
 * - View Shared Files: Access shared images and documents
 * - Schedule Next Session: Send prompts to schedule next session
 */

const Container = styled(FlexBox)`
  flex-direction: column;
  gap: 8px;
  padding: 16px;
`;

const Header = styled(FlexBox)`
  flex-direction: column;
  gap: 8px;
`;

const Description = styled(Typography)``;

const InfoList = styled(FlexBox)`
  flex-direction: column;
  gap: 8px;
`;

const InfoItem = styled(FlexBox)`
  flex-direction: column;
  gap: 8px;
`;

const ItemTitle = styled(Typography)``;

const ItemDescription = styled(Typography)``;

/**
 * @description
 * Array of chat info items describing available features in the menu
 */
const chatInfoItems = [
  {
    id: 1,
    title: "Add New Notes",
    description:
      "Quickly add session notes for the client(s) based on relevant context shared in the chat.",
  },
  {
    id: 2,
    title: "View Shared Files",
    description:
      "Access images and documents shared between you and the client(s) over time.",
  },
  {
    id: 3,
    title: "Schedule Next Session",
    description:
      "Help clients stay on track by sending prompts to schedule their next session based on your availability.",
  },
];

/**
 * @description
 * Renders chat information panel with feature descriptions
 */
const ChatInfo = () => {
  return (
    <Container>
      <Header>
        <Typography variant="web-h4-b" color={colors.DAVY_GREY[800]}>
          Chat info
        </Typography>
        <Description variant="prod-h4-m" color={colors.DAVY_GREY[800]}>
          This is your space to connect with clients. Tap the three-dot menu in
          the top-right corner to:
        </Description>
      </Header>
      <InfoList>
        {chatInfoItems.map(item => (
          <InfoItem key={item.id}>
            <ItemTitle variant="prod-h4-b" color={colors.DAVY_GREY[800]}>
              {item.id}. {item.title}
            </ItemTitle>
            <ItemDescription variant="prod-h4-m" color={colors.DAVY_GREY[800]}>
              {item.description}
            </ItemDescription>
          </InfoItem>
        ))}
      </InfoList>
    </Container>
  );
};

export default ChatInfo;
